import React from "react";
import { LazyMotion, domAnimation } from "framer-motion";

export function WrapRootElement({ element }: { element: React.ReactNode }) {
  return (
    <LazyMotion features={domAnimation}>
      {element}
    </LazyMotion>
  );
}
